export const stripTag = (text: string, tagName: string): string =>
  text.replace(`<${tagName}>`, '').replace(`</${tagName}>`, '')
